/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class TopNavigation extends Component {
  @service
  router;

  @service
  session;

  @tracked open = false;

  get navigationClass() {
    return this.open ? 'active' : '';
  }

  get navigationButtonClass() {
    return 'nav-toggle-button ' + (this.open ? 'active' : '');
  }

  toggle() {
    this.toggleProperty('open');
  }

  @action
  logout() {
    this.session.logout('topNavigation');
  }

  @action
  navigate(route, params) {
    this.toggle();

    if (Array.isArray(params)) {
      this.router.transitionTo(route, ...params);
    } else {
      this.router.transitionTo(route);
    }
  }
}
